import { MILESTONE_TRACKER } from 'lib/constants'
import React from 'react'
import Tooltip from '@mui/material/Tooltip'

export default function MileStoneTracker({ data }) {
  const milestoneTracker = data?.map((item) => ({
    developer: item.developer,
    current_stage: item.actual_funding_stage,
    project: item.project,
    purpose: item.purpose,
    current_stage_code: MILESTONE_TRACKER.find((stage) => stage.name === item.actual_funding_stage)
      ?.code,
    last_stage: item.required_funding_stage_today,
    last_stage_code: MILESTONE_TRACKER.find(
      (stage) => stage.name === item.required_funding_stage_today
    )?.code,
  }))

  return (
    <section className="relative w-full">
      <div className="flex flex-col gap-y-4 -ml-8 absolute z-10 bottom-12">
        {milestoneTracker.map((item) => (
          <div key={item.developer}>
            <Tooltip
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, -14],
                      },
                    },
                  ],
                },
              }}
              title={
                <div className="flex flex-col gap-y-2 text-sm">
                  <span>Project: {item.project} </span>
                  <span>Purpose: {item.purpose} </span>
                  <span>Actual funding stage: {item.current_stage} </span>
                  <span>Required funding stage: {item.last_stage} </span>
                </div>
              }
              className="grid grid-cols-[16px_auto] w-[200px] items-center "
            >
              <div className=" grid place-items-center w-5 h-5 bg-02  text-white rounded-full container-shadow text-sm 2xl:text-base font-libre "></div>
              <div
                style={{
                  width: `${
                    MILESTONE_TRACKER.find((stage) => stage.code === item.last_stage_code)?.width +
                    25
                  }px`,
                }}
                className="relative  ml-0.5 bg-[#912c0d] bg-opacity-[85%]  container-shadow h-2.5"
              >
                <div
                  className="z-50 h-full"
                  style={{
                    width: `${MILESTONE_TRACKER.find((stage) => stage.code === item.current_stage_code)?.width + 25}px`,
                    backgroundColor: '#5a6f41',
                  }}
                ></div>
              </div>
            </Tooltip>
          </div>
        ))}
      </div>
      <div className="flex  gap-x-1.5 z-20">
        {MILESTONE_TRACKER.map((stage) => (
          <div className="w-12 h-[190px]  relative ">
            <Tooltip
              slotProps={{
                popper: {
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, -200],
                      },
                    },
                  ],
                },
              }}
              title={<span className="text-sm">{stage.name} </span>}
              className="text-3xl "
            >
              <div
                className={` w-12 h-[190px]  bg-opacity-[${stage.opacity}]`}
                style={{
                  backgroundColor: stage.color,
                  opacity: stage.opacity,
                }}
              ></div>
              <p className="absolute  left-3 text-02 text-sm font-libre bottom-4 ">{stage.code}</p>
            </Tooltip>
          </div>
        ))}
      </div>
    </section>
  )
}
